import React, {Component} from 'react';
import ReactPaginate from 'react-paginate';

import '../../../scss/react-paginate.scss';


export const ITEMS_PER_PAGE = 12;

export default class CustomPagination extends React.Component{
    render() {
        if(this.props.total < ITEMS_PER_PAGE) {
            return null;
        }

        return <div className={'pagination-container'}>
            <ReactPaginate previousLabel={"«"}
                           nextLabel={"»"}
                           breakLabel={<a>...</a>}
                           forcePage={this.props.page - 1}
                           breakClassName={"break-me"}
                           pageCount={Math.ceil(this.props.total/ITEMS_PER_PAGE)}
                           marginPagesDisplayed={5}
                           pageRangeDisplayed={1}
                           onPageChange={this.props.onPageChange}
                           containerClassName={"pagination"}
                           subContainerClassName={"pages pagination"}
                           activeClassName={"active"} />
        </div>;
    }
};






// WEBPACK FOOTER //
// ./web/src/components/common/CustomPagination.jsx